import en_US from './en-US.json';

const translations = {
  'en-US': en_US,
};

export default translations;
